import React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */
        "@omni/components/components/Account/Profile/ProfileMenuButton/profileMenuButton.container"
    ).then((module) => ({
        default: module.ProfileMenuButtonContainer
    }))
);
